export default __webpack_public_path__ + "static/media/analyst_drawer_op_pct.5db1d1d1.svg";